<section id="file-upload">
  <div class="row">
    <div class="col-md-6 upload-btn-wrapper m-10">

      <label class="custom-file mb-3">
        <span class="btn btn-raised btn-success btn-sm">
          @if (isUploading) {
          <i class="ft-loader spinner font-small-5"></i>
          }
          @if (!isUploading) {
          <span class="fa fa-upload"></span>
          }Upload File
        </span>
        <input type="file" (change)="onFileChange($event)" />
        <span class="custom-file-control"></span>
      </label>
    </div>

    <div class="col-md-9">
    </div>
  </div>
</section>